"use strict";
var controller = function($scope, $rootScope, $http, $timeout) {
  var init = function() {
    $scope.file = "";
    $scope.refresh();
  };
  $scope.refresh = function() {
    $http.get('/api/log/download').then(function(response) {
      $scope.file = response.data;
    });
  };
  init();
};
module.exports = controller;
